export const EVENT_ASSIGN_TABLES_QUERY_KEY = "EventTableSettings";
export const EVENT_ASSIGN_TABLE_PRESETS_QUERY_KEY = "EventTableSettingPresets";
export const DRAGGABLE_ATTENDEE_TYPE = "assign-tables-attendee";
export enum AssignTableErrors {
  NO_EVENT_ID = "NO_EVENT_ID",
  NO_PRESET_ID = "NO_PRESET_ID",
}
